<template>
  <div class="diaglog-wrapper">
    <!-- BindAccount和SwitchAccount，这两个不能用v-if因为有异步骚操作在关闭弹窗后要展示错误提示，v-if逻辑就销毁掉这个逻辑了，并且用的都是OceanUI里面的组件不是本文件夹组件 -->
    <BindAccount
      :gameId="gameId"
      :isAndroid="isAndroid"
      :HIDE_DIALOG="HIDE_DIALOG"
      :DEBIND_STATE="DEBIND_STATE"
      :DEBIND_ACCOUNT="DEBIND_ACCOUNT"
      :BIND_ACCOUNT="BIND_ACCOUNT"
      :BIND_STATE="BIND_STATE"
      :GET_BIND_REWARD="GET_BIND_REWARD"
      :globalConfig="globalConfig"
      :isServerEnv="isServerEnv"
      v-show="showingDialogType === BINDING_DIALOG && !visiblePlatformAccount"
      @bindFail="bindFail"
      @feedbackPage="feedbackPage"
    ></BindAccount>
    <SwitchAccount
      :gameId="gameId"
      :isAndroid="isAndroid"
      :SWITCH_ACCOUNT="SWITCH_ACCOUNT"
      :REFRESH_LOGIN_STATUS="REFRESH_LOGIN_STATUS"
      :BIND_STATE="BIND_STATE"
      :HIDE_DIALOG="HIDE_DIALOG"
      :SET_ORIGIN_USER_TYPE_ACTION="SET_ORIGIN_USER_TYPE_ACTION"
      :globalConfig="globalConfig"
      :isServerEnv="isServerEnv"
      :switchAccountCallback="refreshExeClient"
      v-show="
        showingDialogType === SWICH_ACCOUNT_DIALOG && !visiblePlatformAccount
      "
      @switchFail="bindFail"
    ></SwitchAccount>
    <PlatformAccount v-if="visiblePlatformAccount"></PlatformAccount>
    <transition name="scale-in" mode="out-in">
      <Tips
        v-show="
          showingDialogType === SWICH_TIPS_DIALOG && !visiblePlatformAccount
        "
      ></Tips>
    </transition>
  </div>
</template>
<script>
import PlatformAccount from './PlatformAccount';
import Tips from '../Tips';
import { isAndroid } from '../../utiles/device';
import { HIDE_DIALOG } from '../../store/dialog';
import {
  DEBIND_ACCOUNT,
  DEBIND_STATE,
  BIND_ACCOUNT,
  BIND_STATE,
  GET_BIND_REWARD,
  REFRESH_LOGIN_STATUS,
  SWITCH_ACCOUNT,
  UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE
} from '../../store/account';
import { SET_ORIGIN_USER_TYPE_ACTION } from '../../store/passport/accountSetting';
import globalConfig, { isServerEnv } from '../../utiles/globalConfig';
import { getHrefParam } from '../../store/ultile';
import * as exesdk from '../../utiles/exeSdk';

let gameId = getHrefParam('gameId');
export default {
  data() {
    return {
      gameId,
      isAndroid: isAndroid(),
      HIDE_DIALOG,
      DEBIND_ACCOUNT,
      DEBIND_STATE,
      BIND_ACCOUNT,
      BIND_STATE,
      GET_BIND_REWARD,
      SWITCH_ACCOUNT,
      REFRESH_LOGIN_STATUS,
      SET_ORIGIN_USER_TYPE_ACTION,
      globalConfig,
      isServerEnv
    };
  },
  computed: {
    visiblePlatformAccount: {
      set(bool) {
        this.$store.commit(UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE, bool);
      },
      get() {
        return this.$store.state.account.visiblePlatformAccountPopup;
      }
    },
    showingDialogType() {
      return this.$store.state.dialog.showingDialogType;
    },
    BINDING_DIALOG() {
      return this.$store.state.dialog.BINDING_DIALOG;
    },
    // DE_BIND_DIALOG(){
    //     return  this.$store.state.dialog.DE_BIND_DIALOG;
    // },
    SWICH_ACCOUNT_DIALOG() {
      return this.$store.state.dialog.SWICH_ACCOUNT_DIALOG;
    },
    SWICH_TIPS_DIALOG() {
      return this.$store.state.dialog.SWICH_TIPS_DIALOG;
    }
  },
  beforeCreate() {},
  components: {
    PlatformAccount,
    Tips
  },
  methods: {
    bindFail(errMsg) {
      this.$emit('bindFail', errMsg);
    },
    // 刷新微端页面
    refreshExeClient() {
      // const gameId = this.globalConfig.getHrefParam('gameId');
      const from = this.globalConfig.getHrefParam('from');
      if (from === 'exeClient' || from === 'pnsClient') {
        exesdk.sendToIPC('reloadHtmlPage');
      }
    },
    feedbackPage() {
      this.$emit('feedbackPage');
    },
    closeDialog() {
      this.$store.dispatch(this.HIDE_DIALOG);
    }
  },
  watch: {
    showingDialogType(newVal) {
      if (!newVal) {
        window.setHasGlobalDialog && window.setHasGlobalDialog(false);
        return;
      }
      if (newVal === this.BINDING_DIALOG) {
        window.setHasGlobalDialog && window.setHasGlobalDialog(true);
        window.globalHideDialogCb = this.closeDialog;
        return;
      }
      if (newVal === this.SWICH_ACCOUNT_DIALOG) {
        window.setHasGlobalDialog && window.setHasGlobalDialog(true);
        window.globalHideDialogCb = this.closeDialog;
      }
    }
  }
};
</script>
